<msc-link-preview *ngFor="let link of links" [link]="link" [backgroundColor]="backgroundColor" [timeline]="timeline"></msc-link-preview>
